// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var NpsLabel$ReactHooksTemplate = require("./NpsLabel.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var NpsRepresentationConfig$ReactHooksTemplate = require("./NpsRepresentationConfig.res.js");

function NpsSquareBoxForm$NpsItem(props) {
  var onSelection = props.onSelection;
  var step = props.step;
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("span", {
                          children: String(step)
                        }),
                    className: "py-5 small:py-2"
                  }),
              className: props.className,
              style: props.style,
              onClick: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onSelection, step);
                })
            });
}

var NpsItem = {
  make: NpsSquareBoxForm$NpsItem
};

function colorBasedOnLikelyness(scale, index) {
  if (scale === "FiveScale") {
    switch (index) {
      case 0 :
      case 1 :
      case 2 :
      case 3 :
          return "#E60000";
      case 4 :
          return "#F79406";
      case 5 :
          return "#21AD04";
      default:
        return "#ffffff";
    }
  } else {
    switch (index) {
      case 0 :
      case 1 :
      case 2 :
      case 3 :
      case 4 :
      case 5 :
      case 6 :
          return "#E60000";
      case 7 :
      case 8 :
          return "#F79406";
      case 9 :
      case 10 :
          return "#21AD04";
      default:
        return "#ffffff";
    }
  }
}

function imageBasedOnIndex(scale, index, imageClassName) {
  if (scale === "FiveScale") {
    if (index !== 4) {
      if (index !== 5) {
        return JsxRuntime.jsx("img", {
                    className: imageClassName,
                    src: Image$ReactHooksTemplate.sadButton
                  });
      } else {
        return JsxRuntime.jsx("img", {
                    className: imageClassName,
                    src: Image$ReactHooksTemplate.happyButton
                  });
      }
    } else {
      return JsxRuntime.jsx("img", {
                  className: imageClassName,
                  src: Image$ReactHooksTemplate.neutralButton
                });
    }
  }
  if (index >= 9) {
    if (index < 11) {
      return JsxRuntime.jsx("img", {
                  className: imageClassName,
                  src: Image$ReactHooksTemplate.happyButton
                });
    }
    
  } else if (index >= 7) {
    return JsxRuntime.jsx("img", {
                className: imageClassName,
                src: Image$ReactHooksTemplate.neutralButton
              });
  }
  return JsxRuntime.jsx("img", {
              className: imageClassName,
              src: Image$ReactHooksTemplate.sadButton
            });
}

function normalizeConfiguration(config) {
  if (config === undefined) {
    return ;
  }
  var match = Js_json.decodeObject(config);
  if (match !== undefined) {
    return config;
  }
  var s = Js_json.decodeString(config);
  if (s === undefined) {
    return ;
  }
  try {
    var parsed = JSON.parse(s);
    var match$1 = Js_json.decodeObject(parsed);
    if (match$1 !== undefined) {
      return parsed;
    } else {
      return ;
    }
  }
  catch (exn){
    return ;
  }
}

function NpsSquareBoxForm(props) {
  var contentOnly = props.contentOnly;
  var overrideQuestionBlock = props.overrideQuestionBlock;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var nps = props.nps;
  var scale = Nps$ReactHooksTemplate.scale(nps);
  var includeZero = Nps$ReactHooksTemplate.includeZero(nps);
  var configForCategories = normalizeConfiguration(props.configuration);
  var scaleString = NpsRepresentationConfig$ReactHooksTemplate.scaleStringFromNps(scale, includeZero);
  var categoryRanges = NpsRepresentationConfig$ReactHooksTemplate.getCategoryRangesFromConfig(configForCategories, scaleString);
  var categoryColors = NpsRepresentationConfig$ReactHooksTemplate.getCategoryColorsFromConfig(configForCategories);
  var colorForStep = function (v) {
    return NpsRepresentationConfig$ReactHooksTemplate.colorForStepValue(scaleString, v, categoryRanges, categoryColors);
  };
  var steps = function (count, offset) {
    return Belt_List.makeBy(count, (function (x) {
                  return x + offset | 0;
                }));
  };
  var stepsCount;
  stepsCount = scale === "FiveScale" ? (
      includeZero ? 6 : 5
    ) : (
      includeZero ? 11 : 10
    );
  var normalCss = "  w-1/" + String(stepsCount) + " focus:outline-none text-white text-xl\n    font-medium ";
  var startRating = includeZero ? 0 : 1;
  var endRating;
  endRating = scale === "FiveScale" ? 5 : 10;
  var selectedCss = function (x) {
    if (Nps$ReactHooksTemplate.isAnswer(nps, x)) {
      return "text-blue-800";
    } else {
      return "";
    }
  };
  var rmName = CustomerInfo$ReactHooksTemplate.rmName(props.customerInfo);
  var questionText = Nps$ReactHooksTemplate.getTextTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)).replace("${RM_NAME}", rmName);
  var items = function (a, b) {
    var count = (b - a | 0) + 1 | 0;
    return $$Array.of_list(Belt_List.map(steps(count, a), (function (x) {
                      return JsxRuntime.jsx(NpsSquareBoxForm$NpsItem, {
                                  step: x,
                                  className: normalCss + (" " + selectedCss(x)),
                                  onSelection: (function (y) {
                                      Curry._1(onChange, Nps$ReactHooksTemplate.setAnswer(nps, y));
                                    }),
                                  style: {
                                    backgroundColor: colorForStep(x)
                                  }
                                }, String(x));
                    })));
  };
  var questionBlock = overrideQuestionBlock !== undefined ? Caml_option.valFromOption(overrideQuestionBlock) : JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
          text: questionText,
          description: Nps$ReactHooksTemplate.getDescriptionTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)),
          mandatory: mandatory,
          surveyTheme: props.surveyTheme,
          substitutionVariables: props.substitutionVariables
        });
  var tmp;
  tmp = scale === "FiveScale" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("p", {
          children: NpsLabel$ReactHooksTemplate.center(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language))),
          className: "pl-12"
        });
  var scaleContent = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: items(startRating, endRating),
                      className: "flex border rounded-sm justify-between divide-x w-full border-white bg-white"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                    }),
                                JsxRuntime.jsx("span", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-5",
                                            src: Image$ReactHooksTemplate.sadRedSmileyYesbank
                                          }),
                                      className: "flex justify-center"
                                    })
                              ],
                              className: "flex flex-col text-center"
                            }),
                        tmp,
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                    }),
                                JsxRuntime.jsx("span", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-5",
                                            src: Image$ReactHooksTemplate.happyGreenSmileyYesbank
                                          }),
                                      className: "flex justify-center"
                                    })
                              ],
                              className: "flex flex-col justify-center"
                            })
                      ],
                      className: " flex justify-between  w-full pt-6 small:pt-3\n            text-lg small:text-xs pb-10"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex flex-col justify-between items-start"
            }),
        className: "w-full py-8 px-16 small:px-6"
      });
  if (contentOnly !== undefined && contentOnly) {
    var tmp$1;
    tmp$1 = scale === "FiveScale" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("p", {
            children: NpsLabel$ReactHooksTemplate.center(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language))),
            className: "pl-12"
          });
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: items(startRating, endRating),
                              className: "flex border rounded-sm justify-between divide-x w-full border-white bg-white"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("p", {
                                              children: NpsLabel$ReactHooksTemplate.left(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: JsxRuntime.jsx("img", {
                                                    className: "h-5",
                                                    src: Image$ReactHooksTemplate.sadRedSmileyYesbank
                                                  }),
                                              className: "flex justify-center"
                                            })
                                      ],
                                      className: "flex flex-col text-center"
                                    }),
                                tmp$1,
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("p", {
                                              children: NpsLabel$ReactHooksTemplate.right(Nps$ReactHooksTemplate.getLabelTranslation(nps, SurveyLanguage$ReactHooksTemplate.name(language)))
                                            }),
                                        JsxRuntime.jsx("span", {
                                              children: JsxRuntime.jsx("img", {
                                                    className: "h-5",
                                                    src: Image$ReactHooksTemplate.happyGreenSmileyYesbank
                                                  }),
                                              className: "flex justify-center"
                                            })
                                      ],
                                      className: "flex flex-col justify-center"
                                    })
                              ],
                              className: " flex justify-between  w-full pt-6 small:pt-3\n            text-lg small:text-xs pb-10"
                            })
                      ],
                      className: "flex flex-col justify-between items-start"
                    }),
                className: "w-full py-8 px-16 small:px-6"
              });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                questionBlock,
                scaleContent
              ],
              className: props.borderCss
            });
}

var make = NpsSquareBoxForm;

exports.NpsItem = NpsItem;
exports.colorBasedOnLikelyness = colorBasedOnLikelyness;
exports.imageBasedOnIndex = imageBasedOnIndex;
exports.normalizeConfiguration = normalizeConfiguration;
exports.make = make;
/* react/jsx-runtime Not a pure module */
